import { Controller } from "@hotwired/stimulus"
import { mountGlModalShell } from "../lib/gl_modal_shell"

// Opens server-rendered content as a small read-only popup with one Close
// button, stacked OVER whatever is on screen — including an open GOAT Store
// dialog — so closing it leaves that screen exactly as it was. Used by
// "See usage costs" on the Order GOAT CRM dialog (owner, 2026-10-08), so the
// order dialog is never swapped for a second one.
//
// The content ships inert in a <template> (the store dialog adapter refuses a
// nested `.modal` in its response) and is mounted at <body> level through
// lib/gl_modal_shell, which owns the stacking z-index, the bumped backdrop and
// teardown. The store adapter already restores its own dialog's body lock and
// focus when a body-level modal like this one hides.
//
//   %div{ data: { controller: 'template-popup', template_popup_title_value: '…',
//                 template_popup_icon_value: 'ph-fill ph-receipt' } }
//     %button{ type: 'button', data: { action: 'template-popup#open' } } …
//     %template{ data: { template_popup_target: 'content' } } …
export default class extends Controller {
  static targets = ["content"]
  static values = { title: String, icon: { type: String, default: "ph-fill ph-info" } }

  disconnect() {
    this.shell?.destroy()
    this.shell = null
  }

  open(event) {
    event?.preventDefault()
    if (this.shell || !this.hasContentTarget) return

    this.shell = mountGlModalShell({
      idPrefix: "template-popup",
      title: this.titleValue,
      headerIcon: this.iconValue,
      headerClass: "gl-modal-header--dark",
      scrollable: true,
      buttons: [{ text: "Close", className: "gl-btn gl-btn-primary", dismiss: true }],
      onMounted: (shell) => shell.body.appendChild(this.contentTarget.content.cloneNode(true)),
      onHidden: () => {
        this.shell = null
      },
    })
  }
}
